export default {
  init() {
    // JavaScript to be fired on the Products page
  },
  finalize() {
    $('body').scrollspy({ target: '#nav-products', offset: 75 });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/products.js